import { render, staticRenderFns } from "./TCHover.vue?vue&type=template&id=109faa5a&scoped=true"
import script from "./TCHover.vue?vue&type=script&lang=ts"
export * from "./TCHover.vue?vue&type=script&lang=ts"
import style0 from "./TCHover.vue?vue&type=style&index=0&id=109faa5a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "109faa5a",
  null
  
)

export default component.exports